import { render } from "./FactorList.vue?vue&type=template&id=3c6044eb"
import script from "./FactorList.vue?vue&type=script&lang=js"
export * from "./FactorList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__